import { useRouteError, isRouteErrorResponse, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertCircle, Home, ArrowLeft } from "lucide-react";

export const ErrorPage = () => {
  const error = useRouteError();

  let title = "Etwas ist schiefgelaufen";
  let message = "Ein unerwarteter Fehler ist aufgetreten.";
  let statusCode: number | null = null;

  if (isRouteErrorResponse(error)) {
    statusCode = error.status;
    if (error.status === 404) {
      title = "Seite nicht gefunden";
      message = "Die angeforderte Seite existiert nicht oder wurde verschoben.";
    } else if (error.status === 403) {
      title = "Zugriff verweigert";
      message = "Sie haben keine Berechtigung, diese Seite anzuzeigen.";
    } else if (error.status === 500) {
      title = "Serverfehler";
      message =
        "Ein interner Serverfehler ist aufgetreten. Bitte versuchen Sie es später erneut.";
    }
  }

  return (
    <div className="flex flex-col items-center justify-center bg-background text-foreground px-4 py-24">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="rounded-full bg-destructive/10 p-4">
            <AlertCircle className="size-12 text-destructive" />
          </div>
        </div>

        {statusCode && (
          <p className="text-6xl font-bold text-muted-foreground">
            {statusCode}
          </p>
        )}

        <div className="space-y-2">
          <h1>{title}</h1>
          <p className="text-muted-foreground">{message}</p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
          <Button variant="outline" onClick={() => window.history.back()}>
            <ArrowLeft />
            Zurück
          </Button>
          <Button asChild>
            <Link to="/">
              <Home />
              Zur Startseite
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};
